module.exports = __webpack_public_path__ + "static/media/wb-banner-definitive-english.3d5fa3fc.svg";